<template>
  <div class="mb-3">
    <h3 :class="{ 'mt-0': !isAVRMobile }">{{ title }}</h3>
    <p v-if="text">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'Hero',
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped>
h3 {
  font-size: 28px;
  font-weight: bold;
  color: #19222b;
  line-height: 35px;
}
p {
  font-size: 16px;
  font-weight: normal;
  color: #4b5863;
}
</style>
